export default {
      id: "icon_aha-usage",
      viewBox: "0 0 31 42",
      url: __webpack_public_path__ + "sprite.svg#icon_aha",
      toString: function () {
        return this.url;
      }
    }